import { RootState } from 'store/rootReducer';
import { getContractBasedStateSelector } from '@cp-shared-19/frontend-integration';

export const FinancialDetailsStateSelector = getContractBasedStateSelector(
    (state: RootState) => state.financialDetails,
);
